import React, { FC, useCallback, useState } from 'react'
import styled from 'styled-components'

import AngleRightIcon from '@Assets/SVG/AngleRight'
import { Accordion, AccordionHeaderWrapper, AccordionIconWrap, AccordionProps } from '@Components/CMS/Accordion'
import { SVGIcon } from '@Components/Icons'
import { SidePane } from '@Components/SidePane'
import { up } from '@Globals/Style/breakpoints'
import DefaultTheme from '@Globals/Style/theme'
import { useMediaQuery } from '@Globals/useMediaQuery'

export const SidepaneAccordion = styled(Accordion)`
  border-top: 1px solid ${({ theme }) => theme.colors.greyLighter};
  margin-bottom: 0;

  ${up('mobileStyleThreshold')} {
    ${AccordionHeaderWrapper} {
      padding: 10px 0;
    }
  }
`

const IconWrapDesktop = styled(AccordionIconWrap)`
  transform: none;
`

const ContentWrapper = styled.div`
  padding: 0 ${({ theme }) => theme.padding.tablet};
`

const IconDesktop = props => (
  <IconWrapDesktop {...props}>
    <SVGIcon icon={AngleRightIcon} size="12px" />
  </IconWrapDesktop>
)

export interface AccordionSidePaneProps {
  className?: string
  disableResponsive?: boolean
  fullScreenOnMobile?: boolean
  header: AccordionProps['header']
  onOpen?: () => void
}

export const AccordionSidePane: FC<AccordionSidePaneProps> = ({ children, className, disableResponsive, fullScreenOnMobile, header, onOpen }) => {
  const [isOpen, setIsOpen] = useState(false)

  const isDesktop = useMediaQuery(`(min-width:${disableResponsive ? '1px' : DefaultTheme.breakpoints.mobileStyleThreshold})`)

  const handleOnClick = useCallback(() => {
    setIsOpen((state) => {
      if (state === false && onOpen) {
        onOpen()
      }

      return !state
    })
  }, [onOpen])

  const icon = props => <IconDesktop {...props} />

  const accordionProps = {
    className,
    handleOnClick,
    header,
    iconRenderer: (isDesktop && icon) || undefined,
    open: !isDesktop && isOpen,
  }

  return (
    <>
      <SidepaneAccordion color="white" {...accordionProps}>
        {children}
      </SidepaneAccordion>

      <SidePane
        fullScreenOnMobile={fullScreenOnMobile}
        isShowing={isDesktop && isOpen}
        onClose={() => setIsOpen(false)}
        showCloseButton
        side="right"
      >
        <ContentWrapper>{children}</ContentWrapper>
      </SidePane>
    </>
  )
}
